import React, { useRef } from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import logo from "./../assets/logo.png";

const Invoice = ({ booking }) => {
  console.log("booking : ", booking)
  const receiptRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));

  // Calculate amounts
  const gstAmount = booking?.amount * (booking?.subService?.gst / 100);
  const subtotal = booking?.amount - gstAmount;

  const downloadPDF = async (id) => {
    const element = receiptRef.current;
    const buttons = element.querySelectorAll(".no-print");
    
    // Hide non-printable elements
    buttons.forEach(button => button.style.display = "none");

    try {
      // Scale down to fit on one page
      const scale = 0.8; // Adjust this value as needed
      const canvas = await html2canvas(element, { 
        scale,
        logging: false,
        useCORS: true,
        scrollX: 0,
        scrollY: 0,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight
      });
      
      const imgData = canvas.toDataURL("image/png", 1.0);
      const pdf = new jsPDF("p", "mm", "a4");
      
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      
      // Calculate dimensions to fit the content on one page
      const imgWidth = pageWidth - 20; // Margins
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      
      // Center the content
      const xPos = 10; // Left margin
      let yPos = 10; // Top margin
      
      // If content is too tall, scale it down further
      const maxHeight = pageHeight - 20; // With margins
      const finalHeight = imgHeight > maxHeight ? maxHeight : imgHeight;
      const finalWidth = imgHeight > maxHeight ? (imgWidth * maxHeight) / imgHeight : imgWidth;
      
      pdf.addImage(imgData, "PNG", xPos, yPos, finalWidth, finalHeight);
      pdf.save(`Invoice_${id}.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
    } finally {
      buttons.forEach(button => button.style.display = "block");
    }
  };

  return (
    <div 
      className="w-full max-w-2xl mx-auto bg-white p-6 rounded-lg shadow-sm border border-gray-200"
      ref={receiptRef}
      style={{ height: 'fit-content' }} // Remove fixed height
    >
      {/* Header */}
      <div className="w-full flex justify-between items-start mb-4 border-b pb-4">
        <img src={logo} alt="Company Logo" className="w-20" />
        <div className="text-right">
          <h1 className="text-2xl font-bold text-gray-800">INVOICE</h1>
          <p className="text-sm text-gray-500">#{booking?._id?.slice(-8).toUpperCase()}</p>
          <button 
            className="no-print mt-2 flex items-center gap-1 bg-blue-600 text-white px-3 py-1 rounded text-sm hover:bg-blue-700 transition-colors"
            onClick={() => downloadPDF(booking._id)}
          >
            <MdOutlineFileDownload className="size-4" />
            Download
          </button>
        </div>
      </div>

      {/* Compact details grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4 text-sm">
        <div>
          <h2 className="font-semibold text-gray-800 mb-1">Service Provider</h2>
          <p className="text-gray-700">Wave Service</p>
          <p className="text-gray-700">support@waveservice.com</p>
          <p className="text-gray-700">+91 9900006581</p>
        </div>
        <div>
          <h2 className="font-semibold text-gray-800 mb-1">Bill To</h2>
          <p className="text-gray-700 font-medium">{user?.name}</p>
          <p className="text-gray-700">{user?.phone}</p>
          <p className="text-gray-700">{user?.email}</p>
        </div>
      </div>

      {/* Compact dates */}
      <div className="grid grid-cols-3 gap-2 mb-4 bg-gray-50 p-2 rounded text-xs">
        <div>
          <p className="text-gray-500">Invoice Date</p>
          <p className="font-medium">{new Date().toLocaleDateString()}</p>
        </div>
        <div>
          <p className="text-gray-500">Service Date</p>
          <p className="font-medium">{booking?.scheduledDate?.slice(0, 10)}</p>
        </div>
        <div>
          <p className="text-gray-500">Service Time</p>
          <p className="font-medium">{booking?.scheduledTime}</p>
        </div>
      </div>

      {/* Compact service table */}
      <div className="mb-4">
        <h2 className="font-semibold text-gray-800 mb-2 border-b pb-1 text-sm">Service Details</h2>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b">
              <th className="text-left py-1">Description</th>
              <th className="text-right py-1">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr className="border-b">
              <td className="py-2">
                <p className="font-medium">{booking?.subService?.name}</p>
                <p className="text-xs text-gray-500">{booking?.location?.address}</p>
              </td>
              <td className="text-right">₹{subtotal.toFixed(2)}</td>
            </tr>
            <tr className="border-b">
              {/* <td className="py-2">GST and other fees ({booking?.subService?.gst}%)</td> */}
               <td className="py-2">GST & other fees (Inclusive) </td>
              <td className="text-right">₹{gstAmount.toFixed(2)}</td>
            </tr>
            <tr className="font-semibold">
              <td className="py-2">Total</td>
              <td className="text-right">₹{booking?.amount?.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Compact payment info */}
      <div className="mb-4 grid grid-cols-2 gap-2 text-sm">
        <div>
          <p className="text-gray-500">Payment Method</p>
          <p className="font-medium capitalize">{booking?.paymentMode}</p>
        </div>
        <div>
          <p className="text-gray-500">Payment Status</p>
          <p className={`font-medium ${booking?.paymentStatus === 'completed' ? 'text-green-600' : 'text-yellow-600'}`}>
            {booking?.paymentStatus}
          </p>
        </div>
      </div>

      {/* Footer */}
      <div className="border-t pt-3 text-center text-xs text-gray-500">
        <p>Thank you for choosing Wave Service</p>
        <p className="mt-1">Contact: support@waveservice.com | +91 9900006581</p>
        <p className="mt-2 text-2xs">Computer generated invoice - No signature required</p>
      </div>
    </div>
  );
};

export default Invoice;